import {FlexColumn, FlexRow} from '@forecast-it/design-system';
import styled from 'styled-components';

export const FlexContainer = styled.div`
	width: 100%;
`;

export const AlreadySharedContainer = styled.div`
	overflow-y: auto;
	overflow-x: hidden;
`;

export const SharedPersonInfoWrapper = styled.div`
	padding: 8px;
	display: flex;
	align-items: center;
`;

/** The email column of a share row that has no matching Forecast person. It takes the row's free
 * space, but must give that space back rather than take it from the role control beside it, so it
 * grows from a zero basis and `min-width: 0` lets it shrink below the address's own width.
 *
 * The truncation has to be stated on the child, not here: the child is the `Detail` that holds the
 * text, and `Detail` renders an `inline-block` whose width shrinks to fit its content. An
 * uncapped inline-block therefore never overflows its own box, so `text-overflow` never fires and
 * the address is hard-clipped mid-character with no ellipsis. `max-width: 100%` is what caps it
 * against the column and lets the ellipsis appear. The `white-space: nowrap` the ellipsis needs
 * comes from the `Detail`'s own `noWrap` prop, which avoids overriding its default `pre-wrap` at
 * equal specificity - a tie that stylesheet insertion order, not intent, would decide. */
export const SharedEmailContainer = styled.div`
	flex: 1;
	min-width: 0;

	> * {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

/** The person block of a share row (also the owner row). A design-system `FlexRow` grows and
 * shrinks from a zero basis already, but every flex item keeps `min-width: auto`, so the
 * unbreakable name and address set a floor the row cannot go below: with the role control now
 * holding its own width, a row wider than the dialog overflows instead, and
 * `AlreadySharedContainer` (`overflow-x: hidden`, no scrollbar) clips the remove link out of
 * reach. Measured in Chrome at a 360px dialog: 145px of the row past its right edge, remove link
 * included. Giving the block a zero floor makes it the part that yields. */
export const SharedPersonRow = styled(FlexRow)`
	min-width: 0;
`;

/** The name and email column inside that block. It needs the same zero floor, and the truncation
 * has to be stated on its children for the reason `SharedEmailContainer` documents: `Text` and
 * `Detail` render inline-blocks that shrink to fit, so an uncapped one never overflows its own box
 * and `text-overflow` never fires. */
export const SharedPersonTextColumn = styled(FlexColumn)`
	min-width: 0;

	> * {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const CrossIconWrapper = styled.div`
	margin-right: 4px;
	visibility: hidden;
	${SharedPersonInfoWrapper}:hover & {
		visibility: visible;
	}
`;
